module.exports = __webpack_public_path__ + "img/logo_home.676d916e.png";